import { t } from "@workspace/strings/web";

/** Shared Clerk auth surface copy — keep web, desktop, and player surfaces aligned. */
export const clerkAuthLocalization = {
  signIn: {
    start: {
      title: t("auth.clerk.signIn.start.title"),
      subtitle: t("auth.clerk.signIn.start.subtitle"),
    },
  },
  signUp: {
    start: {
      title: t("auth.clerk.signUp.start.title"),
      subtitle: t("auth.clerk.signUp.start.subtitle"),
    },
  },
} as const;
